import React from 'react';
import type { MediaDownloadLink, MediaItem } from '../../stores/types/media';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import LoadingSpinner from '../general-components/loading-spinner';
import colors from '../../utils/colors';

interface MyProps {
	index: number
	mediaItem: MediaItem
	canDownload: boolean
	isDownloading: boolean
	download: MediaDownloadLink
	downloadCallback: (
		mediaItem: MediaItem,
		index: number,
		mediaDownloadLink?: MediaDownloadLink,
	) => Promise<void>
}

export default function ISORow(props: MyProps) {
	const {
		index,
		mediaItem,
		canDownload,
		isDownloading,
		download,
		downloadCallback,
	} = props;

	const printOrder = (order?: number): string => (
		order && order > 1 ? ` ${order}` : ''
	);

	const getDownloadTitle = (download: MediaDownloadLink) => (
		download?.label
			? `${download?.label} ISO${printOrder(download?.order)}`
			: 'ISO Recording'
	);

	const getDownloadLabel = (download: MediaDownloadLink) => (
		download?.label
			?? download?.name?.split(' ISO')?.[0]
			?? 'Unnamed'
	);

	return (
		<div
			className="iso-row"
			key={`iso-download-${index}`}
			onClick={() => downloadCallback(mediaItem, index, download)}
		>
			<div className="iso-column-1">
				<div className="iso-label" title={getDownloadTitle(download)}>
					{getDownloadLabel(download)}
				</div>
				<div className="iso-tag">
					{`ISO${printOrder(download?.order)}`}
				</div>
			</div>
			<div className="iso-column-2" style={{ textAlign: 'center' }}>
				{isDownloading 
					&& <LoadingSpinner height={14} width={14} color={colors.textGray} stroke={10} />}
				{(!isDownloading && canDownload) 
					&& <Icon name={ICONS.DOWNLOAD_ICON} color={COLORS.TEXT_GRAY_400} size={13}/>}
			</div>
		</div>
	);
}
